module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Clientmenu",
    class: _vm.menuopen === true ? 'active' : ''
  }, [_c('div', {
    staticClass: "Client-button",
    on: {
      "click": _vm.openClientMenu
    }
  }, [_vm._v("\n    Client: " + _vm._s(_vm.SelectedClient) + "\n    "), _c('br'), _vm._v("\n    Market:\n    " + _vm._s(_vm.SelectedMarket) + "\n  ")]), _vm._v(" "), (_vm.menuopen === true) ? _c('div', {
    staticClass: "Client-selection-popup"
  }, [_c('div', {
    staticClass: "Clientmenu-client"
  }, [_c('h6', [_vm._v("Client")]), _vm._v(" "), _c('ul', _vm._l((_vm.market), function(market) {
    return _c('li', {
      class: _vm.SelectedClient === market.name ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.SelectClient(market.name)
        }
      }
    }, [_vm._v(_vm._s(market.name))])
  }), 0)]), _vm._v(" "), (_vm.clientselectedCheck) ? _c('div', {
    staticClass: "Clientmenu-market"
  }, [_c('h6', [_vm._v("Market")]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.SelectMarket('All Markets')
      }
    }
  }, [_vm._v("All Markets")]), _vm._v(" "), _vm._l((_vm.SortMarket), function(SortMarket) {
    return (_vm.SelectedClient === 'All Clients') ? _c('li', {
      class: _vm.SelectedMarket === SortMarket ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.SelectMarket(SortMarket)
        }
      }
    }, [_vm._v(_vm._s(SortMarket))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.SelectedMarketList), function(SelectedaMarket) {
    return (_vm.SelectedClient !== 'All Clients') ? _c('li', {
      class: _vm.SelectedMarket === SelectedaMarket ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.SelectMarket(SelectedaMarket)
        }
      }
    }, [_vm._v(_vm._s(SelectedaMarket))]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Clientmenu-controls"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm CloseClientPopup",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.CloseClientPopup,
      "keydown": _vm.CloseClientPopup
    }
  }, [_vm._v("\n        Close\n        "), _c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e1bb9da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clientmenu.vue
// module id = 990
// module chunks = 1